export var resolutions = {
  minutes: {
    factor: 6
  },
  hour: {
    factor: 5
  },
  day: {
    factor: 4
  },
  week: {
    factor: 3
  },
  month: {
    factor: 2
  },
  year: {
    factor: 1
  }
};